import { Button, Popover } from "@mui/material";
import CheckCircle from "@mui/icons-material/CheckCircle";
import { useRef, useState } from "react";
import { dateOf, shortDate } from "../../../misc/dates";
import { panelWidth, PickDate } from "./PickDate";

// CompletedDateButton moves a task that has been ticked off to the day it was in fact
// done. The day is all it sets; a task with no completion has nothing to move.
export function CompletedDateButton(props: {
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
}) {
    const anchor = useRef<HTMLButtonElement>(null);
    const [open, setOpen] = useState(false);
    const day = dateOf(props.value);

    return (
        <>
            <Button
                ref={anchor}
                size="small"
                color="success"
                disabled={props.disabled}
                startIcon={<CheckCircle fontSize="inherit" />}
                sx={{
                    borderRadius: 5, borderStyle: "solid",
                    textTransform: "none", fontSize: 12, minWidth: 0, py: 0.125, px: 1,
                    "& .MuiButton-startIcon": { mr: 0.5 },
                }}
                onClick={() => setOpen(true)}
            >
                {shortDate(day)}
            </Button>

            <Popover
                open={open}
                anchorEl={anchor.current}
                onClose={() => setOpen(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <div style={{ width: panelWidth, paddingBottom: 8 }}>
                    <PickDate value={day} onChange={props.onChange} />
                </div>
            </Popover>
        </>
    );
}
